module.exports = __webpack_public_path__ + "img/doctor.65e12354.svg";